import reducer from './reducers';

import * as profileOperations from './operations';

export {
  profileOperations,
};

export default reducer;
